import React from "react";
import { TrixEditor } from "react-trix";
import { Typography } from "@mui/material";

interface IRichTextFieldProps {
  placeholder?: string;
  initialValue?: string;
  onChange: (value: string) => void;
  errorMessage?: string;
}
/**
 * @deprecated Use RichTextEditor instead
 */
export const RichTextField: React.FC<IRichTextFieldProps> = ({
  placeholder,
  initialValue,
  onChange,
  errorMessage,
}) => {
  return (
    <div>
      <TrixEditor
        placeholder={placeholder}
        mergeTags={[]}
        onEditorReady={(editor) => {
          initialValue && editor.insertHTML(initialValue);
        }}
        onChange={(html) => {
          onChange(html);
        }}
      />

      {errorMessage && (
        <Typography
          style={{ margin: "0 16px" }}
          variant="caption"
          color="error"
        >
          {errorMessage}
        </Typography>
      )}
    </div>
  );
};
